import { tKey } from 'ember-intl';
import generateOdValueKey from 'lumen/utils/overview-dashboard/generate-od-value-key';

// Class used to easily use entries that are in the from_dates array of OD API responses
export default class OdFromDateEntry {
  kpis = null;

  get formattedOutlierMessage() {
    let translationKeyTitle = 'market_insight.opportunities.rate.high_short';
    let translationKeyMessage = tKey(
      'overview_dashboard.market.price_opportunity_decrease_message',
    );

    if (this.kpis['price_opportunity.current.value'] < 0) {
      translationKeyTitle = 'market_insight.opportunities.rate.low_short';
      translationKeyMessage = tKey(
        'overview_dashboard.market.price_opportunity_increase_message',
      );
    }

    return {
      translationKeyTitle,
      translationKeyMessage,
    };
  }

  // We keep fromDate separate so that we can easily filter on it (e.g. for day drilldown)
  get fromDate() {
    return this.kpis.from_date;
  }

  // Certain requests will return out of sync info per from date as well
  get opportunity() {
    return this.kpis['price_opportunity.current.value'];
  }

  // Certain requests will return out of sync info per from date as well
  get price() {
    return this.kpis.price;
  }

  constructor(fromDateData) {
    // Keep similar format as the od-api-response class (so OD tiles can work with both)
    this.kpis = fromDateData;
  }

  // Relevant for OTB, Market OTB, Revenue, ADR
  getDataLastUpdateTimestamp(dataKey) {
    return this.kpis[`${dataKey}.timestamp`];
  }

  getDataValueFromKey(odSelections, baseKey, refDateId = null) {
    const odValueKey = generateOdValueKey(odSelections, baseKey, refDateId);

    return this.kpis?.[odValueKey] ?? null;
  }

  // Relevant for OTB, Market OTB, Revenue, ADR
  isDataOutOfSync(dataKey) {
    // Make sure that we can handle the null case (sometimes we don't want to show out of sync info - e.g. past dates)
    if (this.kpis[`${dataKey}.timestamp_ok`] === null) {
      return null;
    }

    // Reversing the value here as timestamp_ok of false means that the data is out of sync
    return !this.kpis[`${dataKey}.timestamp_ok`];
  }
}
